import { Bound } from "lib/@components/binding/Bound"
import { useState } from "react"
import { DifferenceWrapper } from "routes/schedule/compare/differenceWrapper"
import { Box, Stack } from "@mui/material"
import { DifferenceTitle } from "routes/schedule/compare/difference-title"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Status } from "routes/schedule/compare/status"
import { UnitLabel } from "routes/schedule/tasks/unit-label"
import { registerTaskComparitor } from "routes/schedule/compare/register-task-comparitor"
import { TargetEditor } from "routes/schedule/compare/target-editor"
import { EditModeSwitch } from "routes/schedule/compare/edit-mode-switch"
import { Approved } from "routes/schedule/compare/approved"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { IsAccepted } from "event-definitions"

registerTaskComparitor("unitOfMeasure", () => <UOMChange label="unit of measurement" />, true)

export function UOMChange({ label }) {
    const { target, to, acceptId } = useBoundContext()
    const [uom, setUOM] = useBoundValue("unitOfMeasure")
    const [original] = useState(uom)
    const [copied, setCopied] = useState(false)
    const isAccepted = IsAccepted.call({ isAccepted: undefined, id: acceptId ?? target.id })
    const hasDecision = typeof isAccepted === "boolean"

    return (
        <DifferenceWrapper label={`${target.title}: ${label}`}>
            <Stack sx={{ width: "100%", ml: -1.5 }}>
                <DifferenceTitle label={label} />
                <ListItemBox alignItems="center">
                    <Box flex={1} pl={1} mr={2} width={1 / 2}>
                        <TargetEditor>
                            <EditModeSwitch>
                                <Bound task={target}>
                                    <Box p={1} width={1}>
                                        <UnitLabel />
                                    </Box>
                                </Bound>
                            </EditModeSwitch>
                        </TargetEditor>
                    </Box>
                    <Approved>
                        <Status onCopyChanged={setCopied} copy={copy} path="unitOfMeasure" revert={revert} />
                        <Box flex={1} sx={{ opacity: copied && !hasDecision ? 0.5 : 1, p: 1 }}>
                            <Bound target={to} task={to} editMode={false}>
                                <UnitLabel />
                            </Bound>
                        </Box>
                    </Approved>
                </ListItemBox>
            </Stack>
        </DifferenceWrapper>
    )

    function copy() {
        setUOM(to.unitOfMeasure)
    }

    function revert() {
        setUOM(original)
    }
}
